import { get } from "./api.utils";
import { IncidentBannerResponse } from "../types/incidentbanner.typer";

interface IncidentBannerApi {
  hentIncidentBanner: () => Promise<IncidentBannerResponse>;
}

export const incidentBannerApi: IncidentBannerApi = {
  hentIncidentBanner: async (): Promise<IncidentBannerResponse> => {
    const { data } = await get<IncidentBannerResponse>("/incidentbanner");
    return data;
  },
};
